module.exports = __webpack_public_path__ + "static/media/ageCompare.36bc80ce.svg";